import styled from 'styled-components'

export const Container = styled.section`
  margin: 60px 0 32px 0;
  padding: 0 32px;
`

export const Title = styled.h2`
  font-size: 16px;
  color: #686976;
  font-weight: 500;
  width: 100%;
  display: block;
  margin-bottom: 12px;
  margin-left: 8px;
`
